/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import SelectSourceDatasetsDialog3 from "../../../../../components/Tree/Parts/SelectSourceDatasetsDialog/SelectSourceDatasets3"
import { AdasProgramsReportPages } from "../constants"
import { GreenLineReportWizard } from "../../SensorComponentRequirements/GreenLineReportWizard"


/** ReportWizard props */
interface ReportWizardProps {
  page: AdasProgramsReportPages
  onSave: (payload: any) => void
  onClickClose: () => void
  isEdit: boolean
  populateFields?: boolean
}

/**
 * Renders the correct report wizard (red line reports or green line reports)
 * based on the page.
 */
export const ReportWizard = (props: ReportWizardProps) => {
  const {page, onSave, onClickClose, isEdit, populateFields} = props

  return (
    page === AdasProgramsReportPages.SENSOR_COMPONENT_REQUIREMENT ?
      <GreenLineReportWizard
        page={page}
        onSave={onSave}
        onClickClose={onClickClose}
        isEdit={isEdit}
      />
      :
      <SelectSourceDatasetsDialog3
        page={page}
        onSave={onSave}
        onClickClose={onClickClose}
        isEdit={isEdit}
        shouldPrepopulateWithRightClickedNode={populateFields}
      />
  )
}
